import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { campanhaAction } from '../../store/campanha';

//COMPONENTS
import {Modal} from '../inspinia'

class ModalPreview extends React.Component
{
    constructor(props)
    {
        super(props);
        this.iframeRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (
          this.iframeRef.current &&
          (prevProps.preview !== this.props.preview ||
           prevProps.isOpen !== this.props.isOpen)
        ) {
          const iframe = this.iframeRef.current;
          const doc = iframe.contentDocument || iframe.contentWindow.document;
          doc.open();
          doc.write(this.props.preview || '');
          doc.close();
        }
      }

    componentWillReceiveProps(nextProps)
    {
        var ifrm = document.getElementById('iframe');
        ifrm = ifrm.contentWindow || ifrm.contentDocument.document || ifrm.contentDocument;
        ifrm.document.open();
        ifrm.document.write(nextProps.preview);
        ifrm.document.close();
    }

    render()
    {
        return (                       
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} style={{maxWidth: "736px"}}>              
                <h3 className="fs-20 fw-600 text-body mb-4">
                    Pré-visualização
                </h3>

                <iframe id="iframe" ref={this.iframeRef} style={{width: "580px", height: "395px", border: "solid 1px #ccc", borderRadius: "5px", margin: "auto", textAlign: "left"}} />
            </Modal>
        );
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, campanha: state.campanha };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { campanha: bindActionCreators(campanhaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ModalPreview));
